import { render, staticRenderFns } from "./NoData.ts.vue?vue&type=template&id=1425f62f"
import script from "./NoData.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoData.ts.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports